module.exports = __webpack_public_path__ + "img/beachdrink2.ec89f701.jpg";